// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/static/AuditTool/Opengraph/MetatagsCards/LinkedIn.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/static/AuditTool/Opengraph/MetatagsCards/LinkedIn.tsx");
  import.meta.hot.lastModified = "1717182690460.3005";
}
// REMIX HMR END

export function Linkedin({
  title,
  image,
  origin
}) {
  return <div id="linkedin">
      <div className="card-linkedin mt-[13px] min-[770px]:w-[552px] cursor-pointer">
        <div className="card-linkedin-image min-[770px]:h-[288px] min-[770px]:w-[552px] h-[288px] border border-gray-300 bg-contain bg-center bg-cover" style={{
        backgroundImage: `url("${image}")`
      }}></div>
        <div className="border-x border-b border-gray-300 px-4 py-1 bg-[#f2f3f5] text-[#606770] text-[12px] leading-3">
          <p className="text-sm mt-1 text-[#1d2129] font-semibold leading-5 break-words">
            {title}
          </p>
          <span className="leading-5 break-words">{origin}</span>
        </div>
      </div>
    </div>;
}
_c = Linkedin;
var _c;
$RefreshReg$(_c, "Linkedin");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;